<template>
  <div>
    <div class="form-group">
      <Field
        :label="$t('BUYER_DUPLICATE_RESTRICTION')"
        :has-tooltip="true"
        :tooltip-text="$t('BUYER_DUPLICATE_RESTRICTION_TT')"
      >
        <template #element>
          <ValidationProvider
            v-slot="{ classes }"
            ref="settingsCopy.trackBy"
            rules=""
            slim
          >
            <div :class="classes">
              <div class="col-xs-4 col-lg-3 r-form__input">
                <v-select
                  class="m-t-0 p-t-1"
                  v-model="settingsCopy.trackBy"
                  :clearable="false"
                  :searchable="false"
                  :options="restrictionTypes"
                  label="name"
                  :reduce="reduceValues()"
                  :disabled="settingsCopy.trackBy === 'not supported'"
                />
              </div>
            </div>
          </ValidationProvider>
        </template>
      </Field>
    </div>

    <template v-if="showSettings">
      <Field
        :label="$t('BUYER_DUPLICATE_RESTRICTION_CONDITION')"
        :has-tooltip="true"
        :tooltip-text="$t('BUYER_DUPLICATE_RESTRICTION_CONDITION_TT')"
      >
        <template #element>
          <ValidationProvider
            v-slot="{ classes }"
            ref="settingsCopy.previousCallState"
            rules=""
            slim
          >
            <div :class="classes">
              <div class="col-xs-4 col-lg-3 r-form__input">
                <v-select
                  class="m-t-0 p-t-1"
                  v-model="settingsCopy.previousCallState"
                  :options="restrictionCallTypes"
                  :clearable="false"
                  :searchable="false"
                  label="name"
                  :reduce="reduceValues()"
                />
              </div>
            </div>
          </ValidationProvider>
        </template>
      </Field>
      <Field
        :label="$t('BUYER_DUPLICATE_RESTRICTION_DURATION')"
        :has-tooltip="true"
        :tooltip-text="$t('BUYER_DUPLICATE_RESTRICTION_DURATION_TT')"
      >
        <template #element>
          <ValidationProvider
            v-slot="{ classes }"
            ref="settingsCopy.allowDuplicatesAfter"
            rules="required"
            slim
          >
            <div :class="classes">
              <div
                class="col-xs-4 col-lg-3 r-form__input btn-group toggle-wrap"
              >
                <btn-group>
                  <btn
                    v-model="blockDuration"
                    input-type="radio"
                    :input-value="blockDurationValues.always"
                    type="primary"
                  >
                    {{ $t('ALWAYS') }}
                  </btn>
                  <btn
                    v-model="blockDuration"
                    input-type="radio"
                    :input-value="blockDurationValues.time"
                    type="primary"
                  >
                    {{ $t('BUYER_DUPLICATE_RESTRICTION_DURATION_TIME_LIMIT') }}
                  </btn>
                </btn-group>
              </div>
            </div>
          </ValidationProvider>
        </template>
      </Field>

      <Field label=" " :has-tooltip="false" v-if="blockDuration === 'time'">
        <template #element>
          <ValidationProvider
            v-slot="{ classes, errors }"
            ref="settingsCopy.allowDuplicatesAfter"
            rules="required|min_value:1|max_value:365"
            slim
          >
            <div :class="classes">
              <div class="col-sm-4 col-md-9">
                <input
                  type="number"
                  class="form-control width-80"
                  v-model="settingsCopy.allowDuplicatesAfter"
                />
                <span>days</span>

                <label
                  v-if="errors && errors[0]"
                  v-t="'BUYER_DUPLICATE_RESTRICTION_DURATION_INVALID'"
                  name="buyerRouteDuplicatesAllowDuplicatesAfter-invalid-label"
                  data-cy="buyerRouteDuplicatesAllowDuplicatesAfter"
                  class="form-group__label-required vv-invalid"
                />
                <label
                  v-else
                  v-t="'REQUIRED'"
                  class="form-group__label-required m-l-10"
                />
              </div>
            </div>
          </ValidationProvider>
        </template>
      </Field>
    </template>
  </div>
</template>

<script>
import { buyerService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import messages from '../locales';
import sharedMessages from '@/core/locales';
const DEFAULT_LIMIT_DAYS = 30;
const DEFAULT_DURATION = -1;

const blockDurationValues = {
  always: 'always',
  time: 'time',
};

export default {
  name: 'BuyerRouteDuplicateSetting',
  props: {
    setting: {
      type: Object,
    },
  },
  data() {
    return {
      showSettings: false,
      settingsCopy: {},
      blockDuration: null,
      restrictionTypes: [],
    };
  },
  watch: {
    blockDuration(newValue) {
      if (newValue === this.blockDurationValues.always) {
        this.settingsCopy.allowDuplicatesAfter = DEFAULT_DURATION;
      } else if (
        newValue === this.blockDurationValues.time &&
        (!this.setting.allowDuplicatesAfter ||
          this.setting.allowDuplicatesAfter === DEFAULT_DURATION)
      ) {
        this.settingsCopy.allowDuplicatesAfter = DEFAULT_LIMIT_DAYS;
      } else {
        this.settingsCopy.allowDuplicatesAfter =
          this.setting.allowDuplicatesAfter;
      }
      this.change();
    },
    settingsCopy: {
      handler(newValue) {
        this.onRestrictionTypeChange(newValue);
        this.updateSettingsVisibility(newValue.trackBy);

        this.change();
      },
      deep: true,
    },
  },
  computed: {
    blockDurationValues() {
      return blockDurationValues;
    },
    restrictionCallTypes() {
      return [
        {
          name: 'Connected',
          value: 'Connected',
        },
        {
          name: 'Converted',
          value: 'Converted',
        },
      ];
    },
    defaultRestrictionTypeValue() {
      const restrictionType = this.restrictionTypes.find(function (type) {
        return type.default;
      });

      return restrictionType && restrictionType.value;
    },
  },
  methods: {
    change() {
      const emitValue = {
        ...this.settingsCopy,
        allowDuplicatesAfter: +this.settingsCopy.allowDuplicatesAfter,
      };
      this.$emit('change', emitValue);
    },
    reduceValues() {
      return (option) => option.value;
    },
    updateSettingsVisibility(restrictionType) {
      this.showSettings =
        restrictionType === 'buyer' || restrictionType === 'target';
    },
    onRestrictionTypeChange(newValue) {
      if (newValue.trackBy !== 'none' && !newValue.previousCallState) {
        this.settingsCopy.previousCallState = 'Connected';
      }
    },
    isSupported(setting) {
      if (!setting) {
        return true;
      }
      const isPreviousCallStateValid =
        setting.previousCallState == 'Connected' ||
        setting.previousCallState == 'Converted';

      const isTrackByValid =
        setting.trackBy == 'Buyer' || setting.trackBy == 'Target';

      return (
        isPreviousCallStateValid &&
        isTrackByValid &&
        setting.allowDuplicatesAfter >= -1
      );
    },
    initFromRoutingSetting(setting) {
      if (this.isSupported(setting)) {
        if (setting) {
          this.settingsCopy = { ...setting };
        } else {
          this.settingsCopy = {
            trackBy: this.defaultRestrictionTypeValue,
            allowDuplicatesAfter: DEFAULT_DURATION,
          };
        }

        this.settingsCopy.trackBy = this.settingsCopy.trackBy.toLowerCase();
        if (setting && setting.allowDuplicatesAfter != 0) {
          if (setting.allowDuplicatesAfter > 0) {
            this.blockDuration = blockDurationValues.time;
          } else {
            this.blockDuration = blockDurationValues.always;
          }
        } else {
          this.blockDuration = blockDurationValues.always;
        }
      } else {
        this.settingsCopy = {
          trackBy: this.defaultRestrictionTypeValue,
        };
      }
    },
  },
  mounted() {
    this.restrictionTypes = buyerService.getRestrictionTypes();
    this.initFromRoutingSetting(this.setting);

    if (this.settingsCopy.trackBy !== 'not supported') {
      this.restrictionTypes = this.restrictionTypes.filter(
        ({ value }) => value !== 'not supported'
      );
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  },
};
</script>

<style>
</style>